import Papa from "papaparse";

function checkHeaderFormat(array1, array2) {
  // Convert arrays to lowercase sets for case-insensitive comparison
  const set1 = new Set(array1);
  const set2 = new Set(array2);

  // Check if all strings from set1 are present in set2
  for (let string of set1) {
    if (!set2.has(string)) {
      return false; // Found a string that is not present in set2, return false
    }
  }

  return true; // All strings from set1 are present in set2
}

export function checkNull(car, keys) {
  const keysToCheck = keys.split(",");
  if (!Array.isArray(keysToCheck)) {
    throw new Error("keysToCheck must be an array");
  }

  return keysToCheck.some((key) => car[key] === null);
}

const CorrectFormatCar = {
  car_id: "",
  state: "",
  price: 0,
  fromDate: "",
  toDate: "",
};

export function validateCSV(file) {
  return new Promise((resolve, reject) => {
    try {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (header) => String(header).replace(/^\uFEFF/, "").trim(),
        dynamicTyping: true,
        complete: (results) => {
          const { data, meta } = results;

          if (!checkHeaderFormat(Object.keys(CorrectFormatCar), meta.fields))
            return reject({
              message:
                "Please make sure these columns are present car_id, state, price, fromDate, toDate. Column names are case sensitive",
              error: {},
            });

          let validDataCount = 0,
            invalidDataCount = 0;

          const validData = [];

          data.forEach((item) => {
            if (
              checkNull(item, "car_id,state,price,fromDate,toDate") ||
              item.price < 1 ||
              !item.fromDate.includes("/") ||
              !item.toDate.includes("/") ||
              item.fromDate === null ||
              item.toDate === null ||
              item.price === "NA"
            ) {
              invalidDataCount += 1;
            } else {
              validDataCount += 1;

              item.car_id = `${item.car_id}`;
              item.make = item.car_id.trim();

              // item.fromDate = moment(item.fromDate, "DD/MM/YYYY").toISOString();
              // item.toDate = moment(item.toDate, "DD/MM/YYYY").toISOString();
              validData.push(item);
            }
          });

          resolve({
            validDataCount,
            invalidDataCount,
            validData,
          });
        },
      });
    } catch (error) {
      reject({
        message: "File could not be parsed",
        error,
      });
    }
  });
}
